import * as Sentry from '@sentry/browser';
import { getDocument, PDFWorker, GlobalWorkerOptions } from 'pdfjs-dist';

export const checkPdfError = async file => {
  GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.mjs',
    import.meta.url,
  ).toString();
  const worker = new PDFWorker();

  try {
    const fileArrayBuffer = await file.arrayBuffer();
    const pdfDocumentLoading = getDocument({
      data: fileArrayBuffer,
      isEvalSupported: false,
      worker,
    });
    const pdfFile = await pdfDocumentLoading.promise;

    await pdfFile.cleanup();

    return false;
  } catch (error) {
    Sentry.captureMessage(
      `[File Upload] PDF failed to upload with the following error: ${error}`,
      { level: Sentry.Severity.Error },
    );

    return true;
  } finally {
    await worker.destroy();
  }
};
